export { CurrentNextLoadCalc } from './currentNextLoadCalc/CurrentNextLoadCalc';
export { InputCollection } from './inputCollection/InputCollection';
export { LastCalculations } from './lastCalculations/LastCalculations';
export { LastTransferSubjects } from './lastTransferSubjects/LastTransferSubjects';
export { LatestComments } from './latestComments/LatestComments';
export { SuspendedLoadings } from './suspendedLoadings/SuspendedLoadings';
export { UserBookmarks } from './userBookmarks/UserBookmarks';
export { UserBookmarksSettings } from './settings/userBookmarks/UserBookmarksSettings';
export { UserCalendar } from './userCalendar/UserCalendar';
export { UserDashboardSettings } from './settings/userDashboardSettings/UserDashboardSettings';
export { UserFollowedDataObjectGroup } from './settings/userFollowedDataObjectGroup/UserFollowedDataObjectGroup';
export { UserFollowedDataSubject } from './settings/userFollowedDataSubject/UserFollowedDataSubject';
export { WaitingStatuses } from './waitingStatuses/WaitingStatuses';

export { useGetUserDashboardSettingsQuery } from './settings/userDashboardSettings/query/useGetUserDashboardSettingsQuery';

export const SampleCommentsUrl =
  '/data/input-data/details{?descriptionId,groupId,date,subject}&segment=comments';
export const DataObjectDescriptionCommentsUrl =
  '/visual-validation/cross-table{?groupDescriptionRef,valueDate}';
export const DataSubjectsCommentsUrl =
  '/data/data-subjects/{id}?segment=comments';
